import React, {useEffect, useState, useCallback} from 'react';
import { getUser } from '../../../../core/auth/auth';
import InputField from './components/inputField/InputField';
import { InfoInterface } from './interface/SeparationsInterface';
import { getSeparations, getTransp, getUserSeparation, putSeparations, postSeparations } from './Separations.service';
import Table from '../../components/tables/table/Table.component';
import { TableCellInput, TableDiv } from '../../components/tables/tableSeparations/TableSeparations.styles';
import { ButtonGroup } from '../../components/buttonFinish/Button.styles';
import ButtonFinish from '../../components/buttonFinish/ButtonFinish.component';
import useModal from '../../../../hooks/useModal';
import Modal from '../../components/modal/ModalAlert.component';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import FormFilter from './components/form/FormFilterSeparations.component';
import { Title } from '../../../../component/title/Title';
import { useManagement } from '../../../../context/Management';
import ButtonComponent from '../../../../component/buttton/Button.component';
import GridComponent from '../../../../component/grid/GridComponent.component';
import Loader from '../../../../component/Loader/LoaderComponent';
import { useSnackbar } from '../../../../context/Snackbar';
import { useStore } from '../../../../context/Store';


const SeparationCardcomponent = () => {
    const {valueCd} = useManagement();
    const [open, addModal] = useModal();
    const { setSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(Boolean);
    const [permissionTransp, setPermissionTransp] = useState(Boolean);
    const [permissionVehicle, setPermissionVehicle] = useState(Boolean);
    const [permissionSeparate, setPermissionSeparate] = useState(Boolean);
    const [permissionDispatch, setPermissionDispatch] = useState(Boolean);
    const [tableSeparations, setTableSeparations] = useState<InfoInterface[]>([]);
    const [values, setValues] = useState<any>([...tableSeparations]);
    const [errorMensage, setErrorMensage] = useState('');
    const [type, setType] = useState(Boolean);
    const [tableSeparationsAux, setTableSeparationsAux] = useState<InfoInterface[]>([]);
    const [buttonFilter, setButtonFilter] = useState(false);
    const [reload, setReload] = useState(0);
    const [date, setDate] = useState('');
    const [error, setError] = useState<any>('');
    const [loadingButton, setLoadingButton] = useState(Boolean);

    const { setFlag, setStore, flag, store, setSelectedStore } = useStore();

    const separations = async () => {
        setError('')
        try {
            user();
            setLoading(true)
            const res = await getSeparations(`${valueCd}`);
            const restructuring = res.data.map((item:InfoInterface) => {
                const data = {
                    id: item.id,
                    numeroDoTransporte: item.numeroDoTransporte,
                    destino: item.destino,
                    doca: item.doca,
                    veiculo: item.veiculo,
                    volumeEstimado: item.volumeEstimado,
                    volumeSeparado: item.volumeSeparado,
                    volumeAExpedir: 0,
                    volumeExpedido: item.volumeExpedido,
                    cd: item.cd
                }
                return data
            })
            setValues(restructuring);
            setTableSeparations(restructuring);
            setTableSeparationsAux(restructuring);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Verifique com a equipe de TI as suas permissões', type: 'error'});
            console.log(error);
            setError(error)
        }
    }

    const user = async () => {
        setError('');
        try {
            setLoading(true);
            const resUser = getUser();

            const resUserUpperCase = resUser.sAMAccountName.toLocaleUpperCase();
            const res = await getUserSeparation('sap', resUserUpperCase);

            const editTransp = res.data.T_RETORNO.filter((datas: {VALOR:string; VALAPER: string}) => {
                return datas.VALAPER === 'N° DO TRANSPORT';
            });
            const editVehicle = res.data.T_RETORNO.filter((datas: { VALOR: string; VALAPER: string }) => {
                return datas.VALAPER === 'VEICULO';
            });
            const editSeparate = res.data.T_RETORNO.filter((datas: {VALOR:string; VALAPER: string}) => {
                return datas.VALAPER === 'QTD. SEPARADO';
            });
            const editDispatch = res.data.T_RETORNO.filter((datas: {VALOR:string; VALAPER: string}) => {
                return datas.VALAPER === 'QTD. EXPEDIDO';
            });
            setPermissionTransp(editTransp[0].VALOR === '1' ? true : false);
            setPermissionVehicle(editVehicle[0].VALOR === '1' ? true : false);
            setPermissionSeparate(editSeparate[0].VALOR === '1' ? true : false);
            setPermissionDispatch(editDispatch[0].VALOR === '1' ? true : false);
            setLoading(false);
        } catch(error) {
            setLoading(false);
            setSnackbar({msg: 'Erro na comunicação com a API do SAP', subMsg: 'Verifique com a equipe de TI as suas permissões', type: 'error'})
            console.log(error);
            setError(error)
        }
    }

    const transp = async (dataInput:InfoInterface) => {
        setError('');
        try {
            setLoadingButton(true);

            const valueOriginal = dataInput.numeroDoTransporte.padStart(10, '0');
            const res = await getTransp('sap', valueOriginal);

            const verificationExpedition = res.data.T_TRANSPORTE.filter((datas: { KUNNR: string; TPLST: string }) => {
                return datas.KUNNR === dataInput.destino && datas.TPLST === dataInput.cd
            })

            if (res.data.E_MSG !== '') {
                setLoadingButton(false)

                setErrorMensage('Não foi possível finalizar, pois o Número de Transporte '+ dataInput.numeroDoTransporte + ' não existe');
                setType(true);
                addModal(!open);
            } else {

                if (dataInput.veiculo === null && dataInput.volumeSeparado.length === 0 && dataInput.volumeAExpedir.length === 0) {
                    setLoadingButton(false);
                    setErrorMensage('Você não completou todos os campos');
                    setType(true);
                    addModal(!open);
                } else {
                    if (verificationExpedition.length !== 0) {
                        postFinish(dataInput);
                    } else {
                        setLoadingButton(false)
                        setErrorMensage('O destino e a origem do transporte não são iguais ao da expedição');
                        setType(true);
                        addModal(!open);
                    }
                }
            }
        } catch(error) {
            setLoadingButton(false)
            setSnackbar({msg: 'Erro na comunicação com a API do SAP', subMsg: 'Verifique com a equipe de TI as suas permissões', type: 'error'})
            console.log(error);
            setError(error)
        }
    }

    const postFinish = async (inputValues:InfoInterface) => {
        setError('')

        try {
            const data = {
                expedicao: inputValues.id,
                numeroDoTransporte: inputValues.numeroDoTransporte.padStart(10, '0'),
                veiculo: inputValues.veiculo,
                volumeExpedido: inputValues.volumeAExpedir,
                cd: valueCd,
                destino: inputValues.destino
            }
            /* console.log('data', data) */
            const res = await postSeparations(data);
            /* console.log(res) */
            if (res) {
                setType(false);
                addModal(!open);
                separations();
                setLoadingButton(false);
            }
        } catch(error) {
            setLoadingButton(false)
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível fazer a expedição do transporte.', type: 'error'})
            console.log(error);
            setError(error);
        }
    }

    const handleChange = (event:any, id:any) => {
        /* console.log('value' ,event.target.value)
        console.log('id',id) */
        const {value, name} = event.target;
        const data = [...tableSeparations]
        if (name === 'numeroDoTransporte') {
            data[id].numeroDoTransporte = value;
        } else if (name === 'veiculo') {
            data[id].veiculo = value;
        } else if (name === 'volumeSeparado') {
            data[id].volumeSeparado = value;
        } else if (name === 'volumeAExpedir') {
            data[id].volumeAExpedir = value;
        }
        /* console.log('data', data) */
        setValues(data);
        };

        const handleClickFinish = (id:number) => {

            if (values[id].numeroDoTransporte !== null && values[id].numeroDoTransporte.length !== 0) {
                if (values[id].numeroDoTransporte.length <= 10) {
                    if (values[id].volumeAExpedir === '0' || values[id].volumeAExpedir === 0) {
                        setType(true)
                        addModal(!open)
                        setErrorMensage('Preencha o campo Qtd. Expedido');
                    } else {
                        /* console.log('values dentro', values[id]); */
                        transp(values[id]);
                        /* console.log('valor original', values[id].numeroDoTransporte.padStart(10, '0')) */
                        setErrorMensage('');
                    }
                }
            } else if (values[id].numeroDoTransporte === null || values[id].numeroDoTransporte.length === 0) {
                setType(true)
                addModal(!open)
                setErrorMensage('Preencha o campo Número de Transporte');
            }
        }

        const comunicationError = () => {
            setLoadingButton(false);
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível gravar os dados.', type: 'error'})
            console.log(error);
            setError(error);
        }

        const updateDatas = () => {
            setType(true);
            addModal(!open);
            separations();
            setLoadingButton(false);
        }

        const handleClickSave = async (id:string) => {
            setError('')
            setErrorMensage('');
            /* console.log('index', id)
            console.log('valor', values[id].volumeAExpedir) */
            // console.log('valor', values[id])
            const data = {
                id: values[id].id,
                cd: valueCd,
                numeroDoTransporte: values[id].numeroDoTransporte,
                veiculo: values[id].veiculo,
                volumeSeparado: values[id].volumeSeparado,
                destino: values[id].destino
            }
            // console.log("Data gravar: ",data)

                if (data.numeroDoTransporte || data.veiculo || data.volumeSeparado) {
                    if (data.numeroDoTransporte) {

                        try {
                            setLoadingButton(true);
                            const valuePutOriginal = values[id].numeroDoTransporte.padStart(10, '0');

                            const res = await getTransp('sap', valuePutOriginal);
                            if (res.data.E_MSG !== '') {

                                setErrorMensage('Não foi possível gravar, pois o número de transporte ' + values[id].numeroDoTransporte + ' não existe');
                                setType(true);
                                addModal(!open);
                                setLoadingButton(false);
                            } else {
                                try {

                                  updateDatas()
                                    const res = await putSeparations(data);

                                    if (res) {
                                        updateDatas();
                                    }
                                } catch(error) {
                                    comunicationError();
                                }
                            }
                        } catch(error) {
                            comunicationError();
                        }
                    } else {
                        try {
                            setLoadingButton(true);
                            const res = await putSeparations(data);
                            if (res) {
                                updateDatas();
                            }
                        } catch(error) {
                            comunicationError();
                        }
                    }
                } else {
                    setErrorMensage('Nenhum campo foi preenchido');
                    setType(true);
                    addModal(!open)
                }
        }

        const handleSubmitSearch = (separations: InfoInterface) => {
            let tableSeparationsAux: InfoInterface[] = [...tableSeparations].filter((el: InfoInterface) => {
                let includesTransp: boolean = !separations.numeroDoTransporte || String(el.numeroDoTransporte).toLocaleLowerCase().includes(String(separations.numeroDoTransporte).toLowerCase());
                let includesDestination: boolean = !separations.destino || String(el.destino).toLocaleLowerCase().includes(String(separations.destino).toLocaleLowerCase());
                let includesDock: boolean = !separations.doca || String(el.doca).toLocaleLowerCase().includes(String(separations.doca).toLocaleLowerCase());
                let includesVehicle: boolean = !separations.veiculo || String(el.veiculo).toLocaleLowerCase().includes(String(separations.veiculo).toLocaleLowerCase());
                return includesTransp && includesDestination && includesDock && includesVehicle;
            });
            const empty: boolean = !separations.numeroDoTransporte && !separations.destino && !separations.doca && !separations.veiculo;
            setTableSeparationsAux(empty ? [...tableSeparations] : tableSeparationsAux);
        }

        const closeModal = () => {
            addModal(!open);
        }

        const currentDate = useCallback(() => {
            const dateOriginal = new Date().toLocaleString('pt-BR', {dateStyle: 'short', timeStyle: 'short'}).replace(' ', ' - ');
            setDate(dateOriginal);
        }, [date]);

        useEffect(() => {
            currentDate();
            let dateHour = setTimeout(() => {
                currentDate()
            }, 60000);
            return () => {
                clearTimeout(dateHour);
            };
        }, [currentDate]);

        useEffect(() => {
            separations();
        }, [valueCd]);

        useEffect(() => {
            let timer = setTimeout(() => {
                separations();
                var cont = reload + 1;
                setReload(cont);
                }, 1000*60*30);
                return () => {
                    clearTimeout(timer);
                }
        }, [reload]);


    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio"/>
            <Modal type={type} open={!!open} title={errorMensage !== '' ? errorMensage : 'Gravado com sucesso'} onClickSubmit={closeModal}/>
            <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Operações Transporte ({date})</Title>
            <GridComponent justify="flex-end" alignItems="center" margin='0px 0px 10px 0px'>
                <ButtonComponent onClick={() => setButtonFilter(!buttonFilter)} title='filtro' size='medium' margin='16px 0px 0px 0px' />
            </GridComponent>
            <GridComponent>
                {buttonFilter && <FormFilter handleSubmitForm={handleSubmitSearch} />}
            </GridComponent>
            <TableDiv>
                <Table>
                    <Table.Head>
                        <Table.HeadRow>
                            <Table.HeadCell>N° do Transporte</Table.HeadCell>
                            <Table.HeadCell>Destino</Table.HeadCell>
                            <Table.HeadCell>Doca</Table.HeadCell>
                            <Table.HeadCell>Veículo</Table.HeadCell>
                            <Table.HeadCell>Qtd. Estimado (Paletes)</Table.HeadCell>
                            <Table.HeadCell>Qtd. Separado (Paletes)</Table.HeadCell>
                            <Table.HeadCell>Qtd. Expedido (Paletes)</Table.HeadCell>
                            <Table.HeadCell>Qtd. Total (Paletes)</Table.HeadCell>
                        </Table.HeadRow>
                    </Table.Head>
                    <Table.Body>
                        {!valueCd && <p>Selecione um CD</p>}
                        {error && valueCd && !tableSeparationsAux && !tableSeparations && <p>Não existe dados</p>}
                        {loading && <Loader />}
                        {!loading && tableSeparationsAux && tableSeparationsAux.map((item: InfoInterface, id:any) => (
                            <Table.Row key={id}>
                                <TableCellInput>
                                <InputField
                                        label=""
                                        name="numeroDoTransporte"
                                        disabled={permissionTransp}
                                        value={item.numeroDoTransporte === null ? '' : item.numeroDoTransporte}
                                        onChange={(event) => handleChange(event, id)}
                                        type="number"/>
                                </TableCellInput>
                                <Table.Cell>{item.destino}</Table.Cell>
                                <Table.Cell>{item.doca}</Table.Cell>
                                <TableCellInput>
                                <InputField
                                        label=""
                                        name="veiculo"
                                        disabled={permissionVehicle}
                                        value={item.veiculo === null ? '' : item.veiculo}
                                        onChange={(event) => handleChange(event, id)}
                                        type="text"/>
                                </TableCellInput>
                                <Table.Cell>{item.volumeEstimado}</Table.Cell>
                                <TableCellInput>
                                <InputField
                                        label=""
                                        name="volumeSeparado"
                                        disabled={permissionSeparate}
                                        value={item.volumeSeparado}
                                        onChange={(event) => handleChange(event, id)}
                                        type="number"/>
                                </TableCellInput>
                                <TableCellInput>
                                    <InputField
                                            label=""
                                            name="volumeAExpedir"
                                            disabled={permissionDispatch}
                                            value={item.volumeAExpedir}
                                            onChange={(event) => handleChange(event, id)}
                                            type="number"/>
                                </TableCellInput>
                                <Table.Cell>{item.volumeExpedido}</Table.Cell>
                                <ButtonGroup>
                                    {loadingButton ? <ButtonFinish disabled name="gravar" onClick={() => handleClickSave(id)}>Gravar</ButtonFinish> : <ButtonFinish name="gravar" onClick={() => handleClickSave(id)}>Gravar</ButtonFinish>}
                                    {loadingButton ? <ButtonFinish disabled name="expedir" onClick={() => handleClickFinish(id)}>Finalizar</ButtonFinish> : <ButtonFinish name="expedir" onClick={() => handleClickFinish(id)}>Finalizar</ButtonFinish>}
                                </ButtonGroup>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </TableDiv>
        </>
    )
}

export default SeparationCardcomponent
